<template>
  <el-dialog
    :visible.sync="dialogFormVisible"
    width="700px"
    :before-close="close"
    :title="titles[updateType]"
  >
    <el-form ref="form" :model="initForm" :rules="rules">
      <el-form-item label="名称" prop="name" label-width="180px">
        <el-input v-model="initForm.name"></el-input>
      </el-form-item>
      <el-form-item label="类型" prop="type" label-width="180px">
        <el-select v-model="initForm.type" placeholder="请选择">
          <el-option
            style="font-size:16px;"
            v-for="organizational in organizationals"
            :label="organizational.Name"
            :key="organizational.ID"
            :value="organizational.ID"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="上级部门" label-width="180px">
        <el-select v-model="initForm.parent" placeholder="请选择">
          <el-option
            style="font-size:16px;"
            v-for="department in departmentGroup"
            :label="department.Name"
            :key="department.ID"
            :value="department.ID"
          >
          </el-option>
        </el-select>
      </el-form-item>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button @click="$emit('close')">取 消</el-button>
      <el-button type="primary" @click="submit">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { organizationalsList } from "@/components/Index/data.js";
export default {
  props: {
    initForm: {},
    updateType: {}
  },
  data() {
    return {
      dialogFormVisible: true,
      rules: {
        name: [
          {
            required: true,
            message: "请输入组织架构名称",
            trigger: "blur"
          }
        ],
        type: [
          {
            required: true,
            message: "请选择组织架构类型",
            trigger: "blur"
          }
        ]
      },
      titles: {
        add: "新增组织架构",
        edit: "编辑组织架构"
      },
      checkList: [],
      organizationals: organizationalsList
    };
  },
  computed: {
    departmentGroup() {
      let departmentGroup = this.$store.state.departmentGroup;
      return departmentGroup;
    }
  },
  methods: {
    close() {
      this.$emit("close");
    },
    submit() {
      this.$refs.form.validate(valid => {
        if (!valid) return false;
        if (this.updateType === "edit") {
          let url = "structures/" + this.initForm.id + "/";
          this.$http["put"](url, this.initForm, () => {
            this.$baseNotice.message("编辑成功");
            this.$emit("close");
            this.$emit("update");
          });
        } else {
          let url = "structures/";
          this.$http["post"](url, this.initForm, () => {
            this.$baseNotice.message("新增成功");
            this.$emit("close");
            this.$emit("update");
          });
        }
      });
    }
  }
};
</script>
